module.exports = __webpack_public_path__ + "static/media/entrance-1.03ea0503.jpg";